import React, { useEffect, useRef, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { useReactToPrint } from "react-to-print";
import {
  MDBBtn,
  MDBIcon,
  MDBRow,
  MDBCol,
  MDBSpinner,
  MDBContainer
} from "mdb-react-ui-kit";
import PreHeader from "../Home/PreHeader";
import Tabs from "./Tabs";
import AppBuildVersion from "../AppBuildVersion/AppBuildVersion";
import PrintableBillDetails from "./PrintableBillDetails";

const LawsBillDetails = () => {
  const { sessionId, id } = useParams();
  const location = useLocation();
  const [bill, setBill] = useState(null);
  const [ordinal, setOrdinal] = useState(0);
  const [legislatureOrdinal, setLegislatureOrdinal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const query = new URLSearchParams(location.search);
  const openTab = query.get("open_tab") || "Summary";

  const componentRef = useRef();
  const [activeSessionInfo, setActiveSessionInfo] = useState([]);

  useEffect(() => {
    async function fetchDataAndSetBills() {
      try {
        const sessionData = await axios.get(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/sessions/${sessionId}`
        );
        const legislatureOrdinal = sessionData.data.legislature?.ordinals || 0;
        const ordinal = sessionData.data.ordinals || 0;
        const { data: billData } = await axios.get(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/findBySessionIdAndDraftNumber?sessionId=${sessionId}&draftNumber=${id}`
        );
        setBill(billData);
        setOrdinal(ordinal);
        setLegislatureOrdinal(legislatureOrdinal);
        setActiveSessionInfo(sessionData.data);
      } catch (error) {
        console.error("Error fetching data: ", error);
        setError("Failed to load bill details. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    }

    fetchDataAndSetBills();
  }, [sessionId, id]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      console.log("After print");
    },
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <PreHeader />
      <MDBContainer fluid>
        <MDBRow className="g-1">
          <MDBCol size="lg" className="text-center text-md-start">
            <h4 className="mb-2">
              {bill?.billType?.code || ""} {bill?.billNumber}:{" "}
              {bill?.draft?.shortTitle}
            </h4>
          </MDBCol>
          <MDBCol size="auto">
            <MDBBtn
              href={`${process.env.REACT_APP_COMMITTEE_EXPLORER_URI}/#?billId=${bill?.id}&billNumber=${bill?.billNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mb-2"
            >
              <MDBIcon fas icon="check-to-slot" /> Vote History
            </MDBBtn>
            {sessionId > 1000 && (
              <MDBBtn onClick={handlePrint}>
                {" "}
                {isPrintReady ? (
                  <>
                    <MDBIcon fas icon="print" /> Print
                  </>
                ) : (
                  <MDBSpinner size="sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </MDBSpinner>
                )}
              </MDBBtn>
            )}
          </MDBCol>
        </MDBRow>
        <Tabs
          billDetails={bill}
          activeSessionInfo={activeSessionInfo}
          ordinal={ordinal}
          legislatureOrdinal={legislatureOrdinal}
          defaultTab={openTab}
        />
        <AppBuildVersion />
      </MDBContainer>
    </>
  );
};

export default LawsBillDetails;
